export const AD_SELLER_REPUTATION_ATTEMPT = "AD_SELLER_REPUTATION_ATTEMPT";
export const AD_SELLER_REPUTATION_SUCCESS = "AD_SELLER_REPUTATION_SUCCESS";
export const AD_SELLER_REPUTATION_FAILED = "AD_SELLER_REPUTATION_FAILED";
export const LOGOUT = "LOGOUT";